import {
    SPARE_PARTS_INTERNAL_DOWNLOAD_PRESIGNED_URL,
    SPARE_PARTS_INTERNAL_CREATE_ATTACHMENTS,
} from '../../constants/websocketCommands';
import {extractErrorText} from '../actionUtils';
import {errorAlert} from '../alertsActions';
import {uploadSparePartsOrdersAttachment} from '../../api/orders/restSparePartsOrdersAttachments';
import alertMessages from '../../intl/common/alertMessages';

export const SPARE_PARTS_INTERNAL_TICKET_ATTACHMENTS_UPLOADING_ERROR = 'SPARE_PARTS_INTERNAL_TICKET_ATTACHMENTS_UPLOADING_ERROR';
export const SPARE_PARTS_INTERNAL_TICKET_ATTACHMENTS_UPLOADING = 'SPARE_PARTS_INTERNAL_TICKET_ATTACHMENTS_UPLOADING';

export const startUploadInternalTicketAttachments = () => dispatch => {
    return dispatch({type: SPARE_PARTS_INTERNAL_TICKET_ATTACHMENTS_UPLOADING});
};

export const downloadInternalTicketAttachment = (uuid, ticketId, name) => dispatch => {
    return dispatch({
        type: SPARE_PARTS_INTERNAL_DOWNLOAD_PRESIGNED_URL,
        sparePartsWebsocket: true,
        command: SPARE_PARTS_INTERNAL_DOWNLOAD_PRESIGNED_URL,
        payload: {
            attachment: {
                uuid,
                ticketId,
                name
            }
        }
    });
};

export const uploadInternalTicketAttachments = (attachments, correlationId, assignedSolutionGroup) => dispatch => {
    const promises = [];
    const savedAttachments = [];
    attachments.forEach(attachment => {
        promises.push(
            uploadSparePartsOrdersAttachment(attachment.url, attachment.localUrl, attachment.name, attachment.contentType).then(
                () => {
                    window.URL.revokeObjectURL(attachment.localUrl);
                    savedAttachments.push(attachment);
                }, error => {
                    dispatch({type: SPARE_PARTS_INTERNAL_TICKET_ATTACHMENTS_UPLOADING_ERROR});
                    dispatch(errorAlert(...extractErrorText(error, alertMessages.FILE_UPLOAD_ERROR)));
                }
            )
        )
    });
    return Promise.all(promises).then(() => {
            if (savedAttachments.length > 0) {
                dispatch({
                    type: SPARE_PARTS_INTERNAL_CREATE_ATTACHMENTS,
                    sparePartsWebsocket: true,
                    command: SPARE_PARTS_INTERNAL_CREATE_ATTACHMENTS,
                    payload: {
                        attachments: savedAttachments,
                        correlationId,
                        uuid: savedAttachments[0].ticketId,
                        assignedSolutionGroup
                    }
                })
            } else {
                dispatch({
                    type: SPARE_PARTS_INTERNAL_TICKET_ATTACHMENTS_UPLOADING_ERROR,
                })
            }
        }
    )
};
